import { useEffect } from 'react';
import { getDomain } from '../utils/urls';
import { useQueryData } from './useQueryData';
import { useState } from 'react';
// @ts-expect-error - JS file
import { disableHubSpotCookieBanner } from '../utils/disableHubSpotCookieBanner';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { HubSpotLegalButton } from 'ui-addon-i18n/components/HubSpotLegalButton';
import { setLoginMetadataCookieEnableAll } from '../utils/loginMetadataCookie';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useMobileReauthCookie = () => {
  const [isMobileLogin, setIsMobileLogin] = useState(false);
  const {
    allQueryParams
  } = useQueryData();
  const reauth = allQueryParams.reauth;
  useEffect(() => {
    if (reauth) {
      const expires = new Date();
      expires.setTime(expires.getTime() + 10 * 60 * 1000);
      const reauthCookie = Array.isArray(reauth) ? reauth[0] : reauth;
      document.cookie = `hs_reauth=${reauthCookie}; path=/; secure; domain=${getDomain()}; expires=${expires.toUTCString()}`;
      setLoginMetadataCookieEnableAll();
      disableHubSpotCookieBanner();
      FloatingAlertStore.addAlert({
        type: 'info',
        sticky: true,
        'data-test-id': 'mobile-login-cookie-banner',
        message: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "mobileLoginCookieBanner.text"
          }), ' ', /*#__PURE__*/_jsx(FormattedJSXMessage, {
            elements: {
              Link: HubSpotLegalButton
            },
            options: {
              external: true,
              url: 'https://legal.hubspot.com/privacy-policy'
            },
            message: "mobileLoginCookieBanner.link_jsx"
          })]
        })
      });
      setIsMobileLogin(true);
    }
  }, [reauth]);
  return isMobileLogin;
};